module.exports = __webpack_public_path__ + "static/5-7350819f11f730d8e58e05aa56eef17b.png";